define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/location.js
// module id = 2360
// module chunks = 37